import { ButtonLogo, Sidebar } from '@shared';
import { ButtonMedianZone } from './components/ButtonMedianZone';
import { ButtonPolygonsInMedianZone } from './components/ButtonPolygonsInMedianZone';
import { ButtonIntersections } from './components/ButtonIntersections';
import { ButtonAuditPolygons } from './components/ButtonAuditPolygons';
import { ButtonAuditIntersections } from './components/ButtonAuditIntersections';

export const SidebarPolygons = () => {
  return (
    <Sidebar
      upperButtons={
        <>
          <ButtonLogo />
          <ButtonMedianZone />
          <ButtonPolygonsInMedianZone />
          <ButtonIntersections />
          <ButtonAuditPolygons />
          <ButtonAuditIntersections />
        </>
      }
    />
  );
};
